import { api } from '@shared/services/api/axios';

const USE_MOCK_DATA = false;

const MOCK_PLUVIAL_ALERTS = {
  "data": {
    "alerts": [
      // ===== ESTACIÓN IATEMA1 - LLUVIA (10min) =====
      {
        "id": "pluvial-atemajac-10min-accumulated-2025-12-19T04-55-00",
        "accumulatedRainMm": 6.0,
        "rainRate": 0.8,
        "riskLevel": "Riesgo medio",
        "rainCharacter": "Lluvia moderada",
        "triggerType": "accumulated",
        "durationMinutes": 10,
        "municipality": "Atemajac",
        "region": "Sur",
        "stationId": 1001,
        "stationName": "IATEMA1",
        "status": "ongoing",
        "startAt": new Date(Date.now() - 20 * 60 * 1000).toISOString(),
        "endAt": null,
        "createdAt": new Date(Date.now() - 20 * 60 * 1000).toISOString(),
        "rainEventStart": new Date(Date.now() - 40 * 60 * 1000).toISOString(),
        "rainEventEnd": null,
        "rainEventStatus": "active",
        "windEventStart": null,
        "windEventEnd": null,
        "windEventStatus": null
      },
      // INUNDACIÓN (30min) - IATEMA1
      {
        "id": "pluvial-atemajac-30min-accumulated-2025-12-19T04-55-00",
        "accumulatedRainMm": 18.0,
        "rainRate": 0.8,
        "riskLevel": "Riesgo alto",
        "rainCharacter": "Lluvia fuerte",
        "triggerType": "accumulated",
        "durationMinutes": 30,
        "municipality": "Atemajac",
        "region": "Sur",
        "stationId": 1001,
        "stationName": "IATEMA1",
        "status": "ongoing",
        "startAt": new Date(Date.now() - 20 * 60 * 1000).toISOString(),
        "endAt": null,
        "createdAt": new Date(Date.now() - 20 * 60 * 1000).toISOString(),
        "rainEventStart": new Date(Date.now() - 40 * 60 * 1000).toISOString(),
        "rainEventEnd": null,
        "rainEventStatus": "active",
        "windEventStart": null,
        "windEventEnd": null,
        "windEventStatus": null
      },
      {
        "id": "pluvial-atemajac-10min-accumulated-2025-12-19T03-55-00",
        "accumulatedRainMm": 12.5,
        "rainRate": 1.5,
        "riskLevel": "Riesgo extremo",
        "rainCharacter": "Lluvia intensa",
        "triggerType": "accumulated",
        "durationMinutes": 10,
        "municipality": "Atemajac",
        "region": "Sur",
        "stationId": 1001,
        "stationName": "IATEMA1",
        "status": "completed",
        "startAt": new Date(Date.now() - 60 * 60 * 1000).toISOString(),
        "endAt": new Date(Date.now() - 50 * 60 * 1000).toISOString(),
        "createdAt": new Date(Date.now() - 60 * 60 * 1000).toISOString(),
        "rainEventStart": new Date(Date.now() - 70 * 60 * 1000).toISOString(),
        "rainEventEnd": new Date(Date.now() - 50 * 60 * 1000).toISOString(),
        "rainEventStatus": "ended",
        "windEventStart": null,
        "windEventEnd": null,
        "windEventStatus": null
      },
      {
        "id": "pluvial-atemajac-10min-accumulated-2025-12-19T01-55-00",
        "accumulatedRainMm": 10.2,
        "rainRate": 1.2,
        "riskLevel": "Riesgo muy alto",
        "rainCharacter": "Lluvia muy fuerte",
        "triggerType": "accumulated",
        "durationMinutes": 10,
        "municipality": "Atemajac",
        "region": "Sur",
        "stationId": 1001,
        "stationName": "IATEMA1",
        "status": "completed",
        "startAt": new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
        "endAt": new Date(Date.now() - 2.8 * 60 * 60 * 1000).toISOString(),
        "createdAt": new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
        "rainEventStart": new Date(Date.now() - 3.2 * 60 * 60 * 1000).toISOString(),
        "rainEventEnd": new Date(Date.now() - 2.8 * 60 * 60 * 1000).toISOString(),
        "rainEventStatus": "ended",
        "windEventStart": null,
        "windEventEnd": null,
        "windEventStatus": null
      },
      {
        "id": "pluvial-atemajac-10min-accumulated-2025-12-18T22-55-00",
        "accumulatedRainMm": 8.5,
        "rainRate": 0.9,
        "riskLevel": "Riesgo alto",
        "rainCharacter": "Lluvia fuerte",
        "triggerType": "accumulated",
        "durationMinutes": 10,
        "municipality": "Atemajac",
        "region": "Sur",
        "stationId": 1001,
        "stationName": "IATEMA1",
        "status": "completed",
        "startAt": new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
        "endAt": new Date(Date.now() - 5.8 * 60 * 60 * 1000).toISOString(),
        "createdAt": new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
        "rainEventStart": new Date(Date.now() - 6.2 * 60 * 60 * 1000).toISOString(),
        "rainEventEnd": new Date(Date.now() - 5.8 * 60 * 60 * 1000).toISOString(),
        "rainEventStatus": "ended",
        "windEventStart": null,
        "windEventEnd": null,
        "windEventStatus": null
      },
      {
        "id": "pluvial-atemajac-10min-accumulated-2025-12-18T19-55-00",
        "accumulatedRainMm": 5.8,
        "rainRate": 0.6,
        "riskLevel": "Riesgo medio",
        "rainCharacter": "Lluvia moderada",
        "triggerType": "accumulated",
        "durationMinutes": 10,
        "municipality": "Atemajac",
        "region": "Sur",
        "stationId": 1001,
        "stationName": "IATEMA1",
        "status": "completed",
        "startAt": new Date(Date.now() - 9 * 60 * 60 * 1000).toISOString(),
        "endAt": new Date(Date.now() - 8.8 * 60 * 60 * 1000).toISOString(),
        "createdAt": new Date(Date.now() - 9 * 60 * 60 * 1000).toISOString(),
        "rainEventStart": new Date(Date.now() - 9.2 * 60 * 60 * 1000).toISOString(),
        "rainEventEnd": new Date(Date.now() - 8.8 * 60 * 60 * 1000).toISOString(),
        "rainEventStatus": "ended",
        "windEventStart": null,
        "windEventEnd": null,
        "windEventStatus": null
      },
      {
        "id": "pluvial-atemajac-10min-accumulated-2025-12-18T16-55-00",
        "accumulatedRainMm": 3.2,
        "rainRate": 0.3,
        "riskLevel": "Riesgo bajo",
        "rainCharacter": "Lluvia ligera",
        "triggerType": "accumulated",
        "durationMinutes": 10,
        "municipality": "Atemajac",
        "region": "Sur",
        "stationId": 1001,
        "stationName": "IATEMA1",
        "status": "completed",
        "startAt": new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(),
        "endAt": new Date(Date.now() - 11.8 * 60 * 60 * 1000).toISOString(),
        "createdAt": new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(),
        "rainEventStart": new Date(Date.now() - 12.2 * 60 * 60 * 1000).toISOString(),
        "rainEventEnd": new Date(Date.now() - 11.8 * 60 * 60 * 1000).toISOString(),
        "rainEventStatus": "ended",
        "windEventStart": null,
        "windEventEnd": null,
        "windEventStatus": null
      },
      
      // ===== ESTACIÓN IZAPOP1 - INUNDACIÓN EXTREMA (30min) =====
      {
        "id": "pluvial-zapopan-30min-accumulated-2025-12-19T04-55-00",
        "accumulatedRainMm": 35.8,
        "rainRate": 2.85,
        "riskLevel": "Riesgo extremo",
        "rainCharacter": "Inundación intensa",
        "triggerType": "accumulated",
        "durationMinutes": 30,
        "municipality": "Zapopan",
        "region": "Centro",
        "stationId": 5001,
        "stationName": "IZAPOP1",
        "status": "ongoing",
        "startAt": new Date(Date.now() - 5 * 60 * 1000).toISOString(),
        "endAt": null,
        "createdAt": new Date(Date.now() - 5 * 60 * 1000).toISOString(),
        "rainEventStart": new Date(Date.now() - 35 * 60 * 1000).toISOString(),
        "rainEventEnd": null,
        "rainEventStatus": "active",
        "windEventStart": null,
        "windEventEnd": null,
        "windEventStatus": null
      },
      
      // ===== ESTACIÓN ITLAJO1 - INUNDACIÓN MUY ALTA (30min) =====
      {
        "id": "pluvial-tlajomulco-30min-accumulated-2025-12-19T04-55-00",
        "accumulatedRainMm": 28.5,
        "rainRate": 1.3,
        "riskLevel": "Riesgo muy alto",
        "rainCharacter": "Lluvia muy fuerte",
        "triggerType": "accumulated",
        "durationMinutes": 30,
        "municipality": "Tlajomulco de Zúñiga",
        "region": "Centro",
        "stationId": 6001,
        "stationName": "ITLAJO1",
        "status": "ongoing",
        "startAt": new Date(Date.now() - 12 * 60 * 1000).toISOString(),
        "endAt": null,
        "createdAt": new Date(Date.now() - 12 * 60 * 1000).toISOString(),
        "rainEventStart": new Date(Date.now() - 42 * 60 * 1000).toISOString(),
        "rainEventEnd": null,
        "rainEventStatus": "active",
        "windEventStart": null,
        "windEventEnd": null,
        "windEventStatus": null
      },
      
      // ===== ESTACIÓN ICHAPA1 - INUNDACIÓN MODERADA (30min) =====
      {
        "id": "pluvial-chapala-30min-accumulated-2025-12-19T04-55-00",
        "accumulatedRainMm": 11.5,
        "rainRate": 0.9,
        "riskLevel": "Riesgo medio",
        "rainCharacter": "Lluvia moderada",
        "triggerType": "accumulated",
        "durationMinutes": 30,
        "municipality": "Chapala",
        "region": "Ciénega",
        "stationId": 4001,
        "stationName": "ICHAPA1",
        "status": "ongoing",
        "startAt": new Date(Date.now() - 25 * 60 * 1000).toISOString(),
        "endAt": null,
        "createdAt": new Date(Date.now() - 25 * 60 * 1000).toISOString(),
        "rainEventStart": new Date(Date.now() - 55 * 60 * 1000).toISOString(),
        "rainEventEnd": null,
        "rainEventStatus": "active",
        "windEventStart": null,
        "windEventEnd": null,
        "windEventStatus": null
      },
      // ===== ESTACIÓN ITUXPA4 - VIENTO CON HISTORIAL =====
      {
        "id": "pluvial-tuxpan-10min-wind_gust-2025-12-19T04-55-00",
        "accumulatedRainMm": 0,
        "rainRate": 0,
        "riskLevel": "Riesgo alto",
        "rainCharacter": "Viento fuerte",
        "triggerType": "wind_gust",
        "durationMinutes": 10,
        "municipality": "Tuxpan",
        "region": "Sur",
        "windSpeedKmh": 37,
        "windGustKmh": 40.2,
        "windDirectionCardinal": "NE",
        "stationId": 2001,
        "stationName": "ITUXPA4",
        "status": "ongoing",
        "startAt": new Date(Date.now() - 15 * 60 * 1000).toISOString(),
        "endAt": null,
        "createdAt": new Date(Date.now() - 15 * 60 * 1000).toISOString(),
        "rainEventEnd": null,
        "rainEventStatus": null,
        "windEventStart": new Date(Date.now() - 15 * 60 * 1000).toISOString(),
        "windEventEnd": null,
        "windEventStatus": "active"
      },
      {
        "id": "pluvial-tuxpan-10min-wind_gust-2025-12-19T03-55-00",
        "accumulatedRainMm": 0,
        "rainRate": 0,
        "riskLevel": "Riesgo muy alto",
        "rainCharacter": "Viento muy fuerte",
        "triggerType": "wind_gust",
        "durationMinutes": 10,
        "municipality": "Tuxpan",
        "region": "Sur",
        "windSpeedKmh": 52,
        "windGustKmh": 68,
        "windDirectionCardinal": "NE",
        "stationId": 2001,
        "stationName": "ITUXPA4",
        "status": "completed",
        "startAt": new Date(Date.now() - 60 * 60 * 1000).toISOString(),
        "endAt": new Date(Date.now() - 48 * 60 * 1000).toISOString(),
        "createdAt": new Date(Date.now() - 60 * 60 * 1000).toISOString(),
        "rainEventEnd": null,
        "rainEventStatus": null,
        "windEventStart": new Date(Date.now() - 60 * 60 * 1000).toISOString(),
        "windEventEnd": new Date(Date.now() - 48 * 60 * 1000).toISOString(),
        "windEventStatus": "ended"
      },
      {
        "id": "pluvial-tuxpan-10min-wind_gust-2025-12-19T00-55-00",
        "accumulatedRainMm": 0,
        "rainRate": 0,
        "riskLevel": "Riesgo bajo",
        "rainCharacter": "Viento ligero",
        "triggerType": "wind_gust",
        "durationMinutes": 10,
        "municipality": "Tuxpan",
        "region": "Sur",
        "windSpeedKmh": 2.2,
        "windGustKmh": 3.6,
        "windDirectionCardinal": "SE",
        "stationId": 2001,
        "stationName": "ITUXPA4",
        "status": "completed",
        "startAt": new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
        "endAt": new Date(Date.now() - 3.8 * 60 * 60 * 1000).toISOString(),
        "createdAt": new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
        "rainEventEnd": null,
        "rainEventStatus": null,
        "windEventStart": new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
        "windEventEnd": new Date(Date.now() - 3.8 * 60 * 60 * 1000).toISOString(),
        "windEventStatus": "ended"
      },

      // ===== ESTACIÓN IATOTO2 - VIENTO =====
      {
        "id": "pluvial-atotonilco-10min-wind_gust-2025-12-19T00-55-00",
        "accumulatedRainMm": 0,
        "rainRate": 0,
        "riskLevel": "Riesgo bajo",
        "rainCharacter": "Viento ligero",
        "triggerType": "wind_gust",
        "durationMinutes": 10,
        "municipality": "Atotonilco el Alto",
        "region": "Ciénega",
        "windSpeedKmh": 2.2,
        "windGustKmh": 3.6,
        "windDirectionCardinal": "SE",
        "stationId": 3001,
        "stationName": "IATOTO2",
        "status": "completed",
        "startAt": new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
        "endAt": new Date(Date.now() - 3.75 * 60 * 60 * 1000).toISOString(),
        "createdAt": new Date(Date.now() - 3.75 * 60 * 60 * 1000).toISOString(),
        "rainEventEnd": null,
        "rainEventStatus": null,
        "windEventStart": new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
        "windEventEnd": new Date(Date.now() - 3.75 * 60 * 60 * 1000).toISOString(),
        "windEventStatus": "ended"
      },

      // ===== ESTACIÓN ICHAPA1 - LLUVIA (10min) =====
      {
        "id": "pluvial-chapala-10min-accumulated-2025-12-19T04-55-00",
        "accumulatedRainMm": 8.5,
        "rainRate": 0.9,
        "riskLevel": "Riesgo alto",
        "rainCharacter": "Lluvia fuerte",
        "triggerType": "accumulated",
        "durationMinutes": 10,
        "municipality": "Chapala",
        "region": "Ciénega",
        "stationId": 4001,
        "stationName": "ICHAPA1",
        "status": "ongoing",
        "startAt": new Date(Date.now() - 25 * 60 * 1000).toISOString(),
        "endAt": null,
        "createdAt": new Date(Date.now() - 25 * 60 * 1000).toISOString(),
        "rainEventStart": new Date(Date.now() - 35 * 60 * 1000).toISOString(),
        "rainEventEnd": null,
        "rainEventStatus": "active",
        "windEventStart": null,
        "windEventEnd": null,
        "windEventStatus": null
      },

      // ===== ESTACIÓN IZAPOP1 - LLUVIA EXTREMA (10min) =====
      {
        "id": "pluvial-zapopan-10min-accumulated-2025-12-19T04-55-00",
        "accumulatedRainMm": 25.8,
        "rainRate": 2.85,
        "riskLevel": "Riesgo extremo",
        "rainCharacter": "Lluvia intensa",
        "triggerType": "accumulated",
        "durationMinutes": 10,
        "municipality": "Zapopan",
        "region": "Centro",
        "stationId": 5001,
        "stationName": "IZAPOP1",
        "status": "ongoing",
        "startAt": new Date(Date.now() - 5 * 60 * 1000).toISOString(),
        "endAt": null,
        "createdAt": new Date(Date.now() - 5 * 60 * 1000).toISOString(),
        "rainEventStart": new Date(Date.now() - 15 * 60 * 1000).toISOString(),
        "rainEventEnd": null,
        "rainEventStatus": "active",
        "windEventStart": null,
        "windEventEnd": null,
        "windEventStatus": null
      },

      // ===== ESTACIÓN ITLAJO1 - LLUVIA MUY ALTA (10min) =====
      {
        "id": "pluvial-tlajomulco-10min-accumulated-2025-12-19T04-55-00",
        "accumulatedRainMm": 12.5,
        "rainRate": 1.3,
        "riskLevel": "Riesgo muy alto",
        "rainCharacter": "Lluvia muy fuerte",
        "triggerType": "accumulated",
        "durationMinutes": 10,
        "municipality": "Tlajomulco de Zúñiga",
        "region": "Centro",
        "stationId": 6001,
        "stationName": "ITLAJO1",
        "status": "ongoing",
        "startAt": new Date(Date.now() - 12 * 60 * 1000).toISOString(),
        "endAt": null,
        "createdAt": new Date(Date.now() - 12 * 60 * 1000).toISOString(),
        "rainEventStart": new Date(Date.now() - 22 * 60 * 1000).toISOString(),
        "rainEventEnd": null,
        "rainEventStatus": "active",
        "windEventStart": null,
        "windEventEnd": null,
        "windEventStatus": null
      }
    ]
  },
  "metadata": {
    "total": 16
  }
}

export interface PluvialAlertsFilters {
  region?: string;
  municipality?: string;
}

export const getPluvialAlerts = async (filters?: PluvialAlertsFilters) => {
  if (USE_MOCK_DATA) {
    await new Promise(resolve => setTimeout(resolve, 800));
    
    let filteredAlerts = [...MOCK_PLUVIAL_ALERTS.data.alerts];
    
    if (filters?.region) {
      filteredAlerts = filteredAlerts.filter(a => a.region === filters.region);
    }
    if (filters?.municipality) {
      filteredAlerts = filteredAlerts.filter(a => a.municipality === filters.municipality);
    }
    
    return {
      data: { alerts: filteredAlerts },
      metadata: { total: filteredAlerts.length }
    };
  }

  const params = new URLSearchParams();
  if (filters?.region) params.append('region', filters.region);
  if (filters?.municipality) params.append('municipality', filters.municipality);
  
  const queryString = params.toString();
  const url = `/meteorology/pluvial-alerts${queryString ? `?${queryString}` : ''}`;
  
  const response = await api.get(url);
  return response.data;
};
